var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4152 132.001H125.463C132.525 132.001 137.758 125.441 136.188 118.556L127.982 82.5558C126.841 77.5511 122.39 74.0007 117.257 74.0007H37.2651C32.093 74.0007 27.6196 77.6039 26.5177 82.6572L18.6677 118.657C17.1723 125.515 22.3959 132.001 29.4152 132.001Z",
    stroke: "#42CFEE",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4732 30.0007C58.4875 30.0007 42.7917 45.1821 42.7917 63.9649C42.7917 73.4298 46.2298 82.2169 51.8995 89.6647C58.0963 97.8801 65.8002 105.038 74.521 110.656C76.6991 112.053 78.4902 111.955 80.4749 110.656C89.1463 105.038 96.8501 97.8801 103.1 89.6647C108.766 82.2169 112.208 73.4298 112.208 63.9649C112.208 45.1821 96.5125 30.0007 77.4732 30.0007Z",
    fill: "#42CFEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9932 30.0007C24.3447 30.0007 23.0002 28.6912 23.0002 27.0261C23.0002 25.374 24.3447 24.0007 25.9932 24.0007C27.6428 24.0007 29.0002 25.374 29.0002 27.0261C29.0002 28.6912 27.6428 30.0007 25.9932 30.0007Z",
    fill: "#F9C977"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.996 56.0007C126.896 56.0007 126 55.1277 126 54.0177C126 52.9163 126.896 52.0007 127.996 52.0007C129.095 52.0007 130 52.9163 130 54.0177C130 55.1277 129.095 56.0007 127.996 56.0007Z",
    fill: "#FB896E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.989 24.0007C116.241 24.0007 114 21.8181 114 19.0431C114 16.2896 116.241 14.0007 118.989 14.0007C121.738 14.0007 124 16.2896 124 19.0431C124 21.8181 121.738 24.0007 118.989 24.0007Z",
    fill: "#50E2DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.47 77.0007C70.6012 77.0007 64.9992 71.5442 64.9992 64.6065C64.9992 57.7229 70.6012 52.0007 77.47 52.0007C84.3433 52.0007 89.9992 57.7229 89.9992 64.6065C89.9992 71.5442 84.3433 77.0007 77.47 77.0007Z",
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.5,
    cy: 119,
    rx: 17.5,
    ry: 2,
    fill: "#42CFEE",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b",
    x: 18.7917,
    y: 6.00073,
    width: 117.417,
    height: 129.667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 56,
    y: 113,
    width: 43,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.7dc3b9c393b831e3c4cb91fb59705d01.svg";
export { ForwardRef as ReactComponent };